// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"4d2b9569","787":"8443e2d3","850":"9963c4bf"}[chunkId] + ".chunk.js";
};